import { setHeartbeatState } from 'dooh-utils';

export class Store {
  constructor(initState, convertState = s => s) {
    this.state = initState;
    this.convertState = convertState;
    setHeartbeatState({ state: this.convertState(this.state) });
    this.subscribers = [];
    window.store = this;
  }

  subscribe(element) {
    this.subscribers.push(element);
    element.setState(this.state);
  }

  unsubscribe(element) {
    const i = this.subscribers.indexOf(element);
    if (i !== -1) {
      this.subscribers.splice(i, 1);
    }
  }

  update = f => {
    const prevScreen = this.state.screen;

    if (typeof f === 'function') {
      this.state = f(this.state);
    } else if (typeof f === 'object') {
      this.state = Object.assign({}, this.state, f);
    }

    const nextScreen = this.state.screen;
    if (nextScreen != null && prevScreen !== nextScreen && window.track) {
      const payload = { screen: nextScreen };
      if (this.state.session) payload.session = this.state.session;
      window.track('screen', payload, true);
    }
    setHeartbeatState({ state: this.convertState(this.state) });
    this.subscribers.forEach(e => {
      e.setState(this.state);
    });
  };

  setState = s => {
    this.update(ss => Object.assign({}, ss, s));
  };

  getState() {
    return this.state;
  }
}
